import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { CollectionDetailGuard } from '../shop/guards/collection-detail.guard';
import { CollectionProductsGuard } from '../shop/guards/collection-products.guard';
import { CollectionsGuard } from '../shop/guards/collections.guard';
import { ProductDetailGuard } from '../shop/guards/product-detail.guard';
import { AllProductsGuard } from '../shop';

import { KlaviyoGuard } from '../shop/guards/klaviyo.guard';
import { CustomerGuard } from '../shop/guards/customer.guard';
import { SearchResultsGuard } from './guards/search-results.guard';

export const routes: Routes = [
  {
    path: 'search',
    loadComponent: () => import('./containers/search-results/search-results.component').then(m => m.SearchResultsComponent),
    canActivate: [SearchResultsGuard],
  },
  {
    loadComponent: () => import('./containers/product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [ProductDetailGuard, KlaviyoGuard, CustomerGuard],
    runGuardsAndResolvers: 'pathParamsChange',
    // If route is matching pattern /products/:productHandle
    matcher: (url: UrlSegment[], group: UrlSegmentGroup) => {
      return group.segments.length === 2 && group.segments[0].path.endsWith('products')
        ? { consumed: url, posParams: { productHandle: group.segments[1] } }
        : null;
    },
  },
  {
    loadComponent: () => import('./containers/product-catalog/product-catalog.component').then(m => m.ProductCatalogComponent),
    canActivate: [AllProductsGuard],
    // If route is matching pattern /products
    matcher: (url: UrlSegment[], group: UrlSegmentGroup, route) => {
      const parentSeg = group?.parent?.segments;
      return parentSeg?.length === 1 && parentSeg?.[0]?.path.endsWith('products') ? { consumed: url } : null;
    },
  },
  {
    path: '',
    loadComponent: () => import('./containers/collection-overview/collection-overview.component').then(m => m.CollectionOverviewComponent),
    canActivate: [CollectionsGuard],
  },
  {
    path: ':collectionHandle',
    loadComponent: () => import('./containers/product-catalog/product-catalog.component').then(m => m.ProductCatalogComponent),
    canActivate: [CollectionDetailGuard, CollectionProductsGuard],
    runGuardsAndResolvers: 'pathParamsChange',
  },
  {
    path: ':collectionHandle/:productHandle',
    loadComponent: () => import('./containers/product-detail/product-detail.component').then(m => m.ProductDetailComponent),
    canActivate: [CollectionDetailGuard, ProductDetailGuard, KlaviyoGuard, CustomerGuard],
    runGuardsAndResolvers: 'pathParamsChange',
  },
];
